import {inject, injectable} from 'inversify'
import {CaptchaNotValidError, CaptchaService} from '@/src/ports/services/captcha'
import {settings} from '@/src/config/settings'
import type {ILoggerService} from '@/src/ports/services/logger'
import type {IErrorReporter} from '@/src/ports/services/monitoring'
import {DI} from '@/src/config/di/types'

@injectable()
export class YaCaptchaService implements CaptchaService {
  @inject(DI.ILoggerService)
  private logger!: ILoggerService

  @inject(DI.IErrorReporter)
  private errorReporter!: IErrorReporter

  /**
   * Проверяет токен каптчи на валидность. Если не проходит проверку, выбрасывает исключение.
   *
   * @throws CaptchaNotValidError если проверка не пройдена
   * */
  async verify(token: string): Promise<void> {
    if (['development'].includes(settings.NEXT_PUBLIC_APP_ENV)) {
      return
    }

    this.logger.debug('Captcha verification started', {
      hasSecret: !!settings.Y_CAPTCHA_SECRET,
      tokenLength: token?.length,
    })

    const captchaResponse = await fetch('https://smartcaptcha.cloud.yandex.ru/validate', {
      method: 'POST',
      body: new URLSearchParams({
        secret: settings.Y_CAPTCHA_SECRET!,
        token: token,
      }),
    })

    this.logger.debug('Captcha response received', {
      status: captchaResponse.status,
      ok: captchaResponse.ok,
    })

    if (!captchaResponse.ok) {
      this.errorReporter.capture(new CaptchaNotValidError(await captchaResponse.text()))
      throw new CaptchaNotValidError('Форма не прошла проверку на безопасность')
    }

    const captchaInfo = (await captchaResponse.json()) as {status: 'ok' | 'failed'}
    this.logger.debug('Captcha validation result', {status: captchaInfo.status})

    if (captchaInfo.status != 'ok') {
      this.errorReporter.capture(
        new CaptchaNotValidError('Форма не прошла проверку на безопасность'),
        {captchaInfo},
      )
      throw new CaptchaNotValidError('Форма не прошла проверку на безопасность')
    }
  }
}
